import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const FAQS = [{
  q: 'How does Yoga Teaching Vault™ work?',
  a: 'After completing your purchase, you will receive immediate digital access to the complete 6-module system and all five strategic bonuses. You can view the resources on your computer, tablet, or smartphone.'
}, {
  q: 'Is this a physical or digital product?',
  a: 'Yoga Teaching Vault™ is a fully digital product. Nothing will be shipped physically. You will receive immediate online access after your payment is confirmed.'
}, {
  q: 'Is it suitable for newly qualified instructors?',
  a: 'Yes. The resources are organized so newly qualified instructors can begin with clear structures, while experienced teachers can use the system to save time, expand their material, and add variety to their classes.'
}, {
  q: 'Does it work for different experience levels?',
  a: 'Yes. The system includes resources for beginner, intermediate, advanced, and mixed-level teaching environments.'
}, {
  q: 'Can I use it for studio, private, and online classes?',
  a: 'Yes. The classes, sequences, templates, and teaching resources can be adapted for physical studios, private sessions, group environments, and live online teaching.'
}, {
  q: 'Can I adapt the material?',
  a: 'Yes. The resources are designed to give you a professional foundation that you can adapt to your teaching style, class duration, students, and environment.'
}, {
  q: 'Are the five bonuses included in the price?',
  a: 'Yes. During this offer, all five strategic bonuses are included at no additional cost.'
}, {
  q: 'How long will I have access?',
  a: 'Your purchase includes lifetime access to the materials included in your order.'
}, {
  q: 'What makes this different from free online resources?',
  a: 'Free content is usually scattered, inconsistent, and difficult to organize. Yoga Teaching Vault™ brings classes, sequences, teaching guidance, student tools, and instructor templates together in one structured professional system.'
}, {
  q: 'What if it is not right for me?',
  a: 'You are protected by a 7-day money-back guarantee. Open the modules, explore the classes, sequences, and bonuses, and if the system is not right for your teaching, contact us within the guarantee period for a full refund.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-white px-4 py-10 sm:px-6" data-id="element-68" data-mp="28g3zcm1ganps">
      <div className="mx-auto max-w-3xl" data-id="element-69" data-mp="23h9d1a49yh0x">
        <h2 id="faq-title" className="text-center font-head text-2xl font-extrabold uppercase text-charcoal sm:text-3xl" data-id="element-70" data-mp="23fy4yy3sqn40">
          Frequently Asked Questions
        </h2>

        <div className="mt-5 space-y-2" data-id="element-71" data-mp="s3xd3abmyik1">
          {FAQS.map((item, index) => {
          const isOpen = open === index;
          return <div key={item.q} className="overflow-hidden rounded-xl border border-brand/15 bg-ivory" data-id="element-72" data-mp="2zoe16dg1leay" data-mpi={index}>
                <h3 data-id="element-73" data-mp="33q92vj1vxtp9">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left font-head text-sm font-semibold text-charcoal sm:text-base" data-id="element-74" data-mp="33nd1tluqqowl">
                    {item.q}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-75" data-mp="3nbvjzjhbx21s" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-brand/10 px-4 py-3 text-sm leading-snug text-softgray" data-id="element-76" data-mp="1x2txnkfleofn">
                    {item.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}